import React, { useEffect, useState } from "react";

type CountdownProps = {
  targetDate: string; // e.g. "2025-06-28T00:00:00"
  index: number;
  colors: string[];
  hoverColors: string[];
  label: string;
  backgroundImage?: string;
};

const CountdownTimer: React.FC<CountdownProps> = ({
  targetDate,
  index,
  colors,
  hoverColors,
  label,
  backgroundImage,
}) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {
      days: "00",
      hours: "00",
      minutes: "00",
      seconds: "00",
    };

    if (difference > 0) {
      timeLeft = {
        days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(
          2,
          "0"
        ),
        hours: String(
          Math.floor((difference / (1000 * 60 * 60)) % 24)
        ).padStart(2, "0"),
        minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(
          2,
          "0"
        ),
        seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, "0"),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const timeUnit = (value: string, label: string) => (
    <div className="flex flex-col items-center mx-1">
      <div className="gold-text text-4xl font-bold w-14 h-16 flex items-center justify-center rounded">
        {value}
      </div>
      <span className="gold-text text-sm mt-1">{label}</span>
    </div>
  );

  const formattedDate = new Date(targetDate).toLocaleDateString("nl-BE", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div
      className={
        "flex flex-col items-center justify-center text-center w-full h-full rounded p-4 " +
        colors[index % 4] +
        " " +
        hoverColors[index % 4]
      }
      style={{
        backgroundImage: backgroundImage
          ? `url(${backgroundImage})`
          : undefined,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h2 className="text-3xl font-semibold gold-text mb-4 drop-shadow">
        {label}
      </h2>
      <div className="flex justify-center mb-4">
        {timeUnit(timeLeft.days, "Dagen")}
        {timeUnit(timeLeft.hours, "Uren")}
        {timeUnit(timeLeft.minutes, "Minuten")}
        {timeUnit(timeLeft.seconds, "Seconden")}
      </div>
      <div className="gold-text text-xl font-light drop-shadow">
        {formattedDate}
      </div>
    </div>
  );
};

export default CountdownTimer;
